import PropTypes from "prop-types";
import moment from "moment/moment";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ClientSubscriptionListViewApi, SubscriptionCancellationApi } from "store/slices/clientsubscriptionSlice";
import customToast from "component/Toastr";
import { contentErrorMessage } from "store/slices/contentError";
import "component/Sweatalert2";
import "store/slices/subscriptionSlice";
import { useNavigate } from "react-router";
import { SubscriptionProductUsageTable } from "../../../subscriptions/Form/SubscriptionProductsField";
import { SubscriptionDiscountCodeList } from "../../../subscriptions/Form/SubscriptionDiscountCodesField";
import { SubscriptionInclusionsSummary } from "../../../subscriptions/Form/SubscriptionInclusionsField";

const SubscriptionListview = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [openModalTwo, setOpenModalTwo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ModalClickedData, setModalClickedData] = useState(null);
  const [printLoader,,] = useState(false);
  const mounted = useRef(false);
  const profile = useRef({ clientId: props.clientId, version: 0 });
  if (profile.current.clientId !== props.clientId) {
    profile.current = { clientId: props.clientId, version: profile.current.version + 1 };
  }
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);
  useEffect(() => {
    setOpenModal(false);
    setModalClickedData(null);
    setLoading(false);
  }, [props.clientId]);
  const views = props.view;
  const objectData = views && views.data ? views.data : views;

  const tableCellStyle = {
    background: '#f9f6f4',
    padding: '4px',
    textAlign: 'center',
  };
  const headerCellStyle = {
    ...tableCellStyle, // Extend the common styles
    textAlign: 'left',
    fontWeight: 'bold',
  };
  const serviceCellStyle = {
    ...tableCellStyle,
    textAlign: 'left',
  }

  return (
    <div>
      {openModal && (
        <>
          <div className={openModal ? "modal fade show" : "modal fade"} id="add-emailverification" tabIndex="-1" aria-labelledby="addemailverificationModalLabel" style={{ display: openModal ? "block" : "none" }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body pb-0">
                  <div className="p-3">
                    <h5 className="mb-3 fw-semibold text-dark">{t("Confirm subscription cancel")}</h5>
                    <p className="fw-semibold mb-2">{t("Are you sure you want to cancel this subscription?")}</p>
                  </div>
                  <div className="row mt-3 bg-cream p-4 justify-content-center">
                    <div className="col-6">
                      <button className="preview btn me-1 cursor-pointer btn-preview w-100" type="button" onClick={() => {
                        setOpenModal(false);
                      }}>
                        {t("Cancel")}
                      </button>
                    </div>
                    <div className="col-6">
                      <button className="btn btn-primary w-100" type="button" disabled={loading} onClick={() => {
                        const version = profile.current.version;
                        setLoading(true);
                        dispatch(SubscriptionCancellationApi({ client_id: props.clientId ?? ModalClickedData?.client_id, id: ModalClickedData?.id })).then((action) => {
                          if (!mounted.current || profile.current.version !== version) return;
                          if (action.meta.requestStatus === "fulfilled") {
                            dispatch(ClientSubscriptionListViewApi({ client_id: props.clientId ?? ModalClickedData?.client_id }));
                            setLoading(false);
                            setOpenModal(false);
                            customToast.success(t("Your subscription plan cancelled."));
                          } else {
                            setLoading(false);
                            customToast.error(contentErrorMessage(action, t("Unable to cancel this subscription. Please try again.")));
                          }
                        })
                      }}>
                        {loading && <span className="spinner-border spinner-border-sm"></span>}
                        {t("Yes Cancel")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {openModal && <div className="modal-backdrop show"></div>}
        </>
      )}
      {objectData && objectData.length > 0 &&
        Object.keys(objectData).map((item) => {
          // let nextpayment = next_payment_date ? moment(next_payment_date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY") : "";
          const stripe_pause_collection = objectData[item]?.stripe_pause_collection;
          const subscription = objectData[item]?.subscription;
          const total = objectData[item]?.total;
          const totalAmountMinor = total && total.amount_minor !== undefined && total.amount_minor !== null
            ? Number(total.amount_minor)
            : null;
          let name = subscription?.name ?? objectData[item]?.subscription_name ?? "";
          let amount = Number.isFinite(totalAmountMinor)
            ? totalAmountMinor / 100
            : (objectData[item]?.cost ?? 0);
          void (objectData[item]?.client_id);
          void (objectData[item]?.sale_id);
          void (objectData[item]?.subscription_id);
          const lifecycleStatus = objectData[item]?.lifecycle_status ?? (objectData[item]?.is_active == 1 ? "Active" : "");
          let is_subscription_cancel = objectData[item]?.is_plan_cancel;
          // Canonical payment proof describes completed billing, not entitlement eligibility.
          const completedPayments = objectData[item]?.payment_status === "Completed";
          const statusLabel = completedPayments || lifecycleStatus === "Completed" ? "Payments Completed" : lifecycleStatus;
          let lastpayment = objectData[item].payment_history && objectData[item].payment_history.length > 0 ? objectData[item].payment_history : [];
          void (objectData[item]?.one_off_amount ?? 0);
          const Frequency = objectData[item]?.repeat_time_option ?? "";
          void (Frequency ? Frequency.slice(0, -2) : "");
          // const Duration = cartdata && cartdata.length > 0 ? cartdata[0].subscription && cartdata[0].subscription.repeat_time || "" : "";
          void (objectData[item]?.no_of_payments || "");
          const CommenceMentDate = objectData[item]?.commencement_date ? moment(objectData[item]?.commencement_date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY") : "";
          void (objectData[item]?.repeats || "");
          void (lastpayment.length > 0 && lastpayment[0].next_payment_datetime ? lastpayment[0].next_payment_datetime : "");
          void (objectData[item]?.storage_url && objectData[item]?.client_signature ? `${objectData[item]?.storage_url}/${objectData[item]?.client_signature}` : "");
          void (objectData[item]?.status ? objectData[item]?.status : "");

          return (
            <article key={objectData[item]?.id ?? item} className="text-decoration-none event-box-pink mb-3">
              {openModalTwo && (
                <>
                  <div className={openModalTwo ? "modal fade show" : "modal fade"} id="add-emailverification" tabIndex="-1" aria-labelledby="addemailverificationModalLabel" style={{ display: openModalTwo ? "block" : "none" }}>
                    <div className="modal-dialog modal-dialog-centered">
                      <div className="modal-content">
                        <div className="modal-body pb-0">
                          <div className="p-3">
                            <h5 className="mb-3 fw-semibold text-dark">{t("Subscription schedule info")}</h5>
                            <p className="fw-semibold mb-2">{t(`This subscription is set to activated on ${CommenceMentDate}`)}</p>
                          </div>
                          <div className="row mt-3 bg-cream p-4 justify-content-center">

                            <div className="col-6">
                              <button className="btn btn-primary w-100" type="button" disabled={loading} onClick={() => {
                                setOpenModalTwo(false);
                              }}>
                                {t("OK")}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {openModalTwo && <div className="modal-backdrop show"></div>}
                </>
              )}
              <h6 className="mb-4 color-wine fw-semibold d-flex justify-content-between align-items-start">
                <span className="subscriptionlistview-plan-title">
                  {name}
                  <span className="subscriptionlistview-plan-amount ms-2">${amount}</span>
                </span>
                <div>
                  <span
                    className="cancel-subscriptionlistview me-3 cursor-pointer cancelled-sub-status"
                    onClick={() => {
                      // setPrintLoader(true);
                      // dispatch(SubscriptionInvoiceApi({ client_subscription_plan_id: objectData[item]?.id })).then((action) => {
                      //   if (action?.meta?.requestStatus === "fulfilled") {
                      //     setPrintLoader(false);
                      //     window.open(`/subscription-invoice`, '_blank');
                      //   } else {
                      //     setPrintLoader(false);
                      //     customToast.error(t("Something went wrong."));
                      //   }
                      // })
                      window.open(`/subscription-invoice/${objectData[item]?.id}/clientsubscription`, '_blank');
                      // navigate(`/subscription-invoice/${objectData[item]?.id}/clientsubscription`)
                    }}
                  >
                    {printLoader && <span className="spinner-border spinner-border-sm"></span>}
                    Print
                  </span>

                  {is_subscription_cancel == 1 ?
                    (
                      <>
                        <span className="cancel-subscriptionlistview me-3 cursor-pointer cancelled-sub-status">
                          {t(completedPayments ? "Payments Completed" : "Cancelled")}
                        </span>
                      </>
                    ) : (
                      <span className="cancel-subscriptionlistview cancel-btn-sub me-3 cursor-pointer"
                        onClick={() => {
                          setModalClickedData(objectData[item]);
                          setOpenModal(true);
                        }}>
                        Cancel
                      </span>
                    )
                  }
                  {is_subscription_cancel != 1 && statusLabel && (completedPayments || lifecycleStatus !== "Cancelled") ?
                    (
                      <>
                        <span className="active-subscriptionlistview cursor-pointer">
                          {t(statusLabel)}
                        </span>
                      </>
                    ) : (
                      ""
                    )
                  }
                  {stripe_pause_collection ?
                    (
                      <>
                        <span className="active-subscriptionlistview cursor-pointer">
                          Pause ({stripe_pause_collection})
                        </span>
                      </>
                    ) : (
                      ""
                    )
                  }
                </div>
              </h6>
              {objectData[item]?.id != null && <div className="small text-muted mb-2">{t("Subscription")} #{objectData[item].id}</div>}
              {(objectData[item]?.services ?? objectData[item]?.subscriptionservicesmanage ?? []).length > 0 ? (
                <div className="mb-2">
                  <table className="table mb-0">
                    <thead>
                      <tr>
                        <th style={headerCellStyle}>Services Included</th>
                        <th style={tableCellStyle}>Qty</th>
                        <th style={tableCellStyle}>Used</th>
                        <th style={tableCellStyle}>Available</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(objectData[item]?.services ?? objectData[item]?.subscriptionservicesmanage ?? []).map((item, i) => (
                        <tr key={item && item.id ? item.id : i} style={{ border: 'none' }}>
                          <td className="text-dark" style={serviceCellStyle}>{item.name ?? item.services?.name ?? ""}</td>
                          <td style={tableCellStyle}>{item.quantity ?? item.qty ?? 0}</td>
                          <td style={tableCellStyle}>{item.used_quantity ?? item.used_qty ?? 0}</td>
                          <td style={tableCellStyle}>{item.pending_quantity ?? item.pending_qty ?? 0}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : ""}
              <SubscriptionProductUsageTable
                products={objectData[item]?.products ?? objectData[item]?.subscriptionproductsmanage ?? []}
              />
              <SubscriptionInclusionsSummary
                voucherAmount={objectData[item]?.voucher_amount}
                productDiscountPercentage={objectData[item]?.product_discount_percentage}
                currency={objectData[item]?.currency}
              />
              <SubscriptionDiscountCodeList discountCodes={objectData[item]?.discount_codes ?? []} />
              <div className="subscriptionlistview-date my-2 fw-semibold text-dark">
                Payment History
              </div>
              <>
                {lastpayment.length > 0 ? (
                  lastpayment.map((items) => {
                    // payment_date : "2024-01-31 18:19:13"
                    let payment_date = items && items.payment_date ? moment(items.payment_date, "YYYY-MM-DD HH:mm:ss").format('DD/MM/YYYY') : '';
                    const money = items?.amount;
                    const amount_paid = money && typeof money === "object"
                      ? (Number(money.amount_minor) / 100).toFixed(2)
                      : (money ?? 0);
                    let Status = items && (items.status == 'Schedule' ? 'Scheduled' : items.status);
                    let badgeColor = items && items.status && items.status == "Paid" ? "paid" : "unpaid";
                    return (
                      <h6 className="mb-1 subscriptionlistview-date d-flex justify-content-between align-items-baseline">
                        <div>
                          <span className="subscriptionlistview-offer-time">{payment_date}</span>
                        </div>
                        <div>
                          <span className="subscriptionlistview-offer-time">${amount_paid}</span>
                        </div>
                        <div>
                          <span className={`badge ${badgeColor} text-capitalize`}>{Status ? Status : "-"}</span>
                        </div>
                      </h6>
                    )
                  })
                ) : ""}
              </>
            </article>
          );
        })}
    </div>
  );
};

SubscriptionListview.propTypes = {
  clientId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  view: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default SubscriptionListview;
